<template>
  <div class="index">
    <!-- 健康公告页 -->
    <div v-if="preRb">
      <div class="preRebate">
        <div class="preRebate_cont">
          <div style="position: absolute; right: 5px; top: 5px" @click="enterGame">
            <img src="../assets/imgs/closeRb.png" style="width: 24px" alt="" />
          </div>
          <iframe
            style="width: 100%; height: 100%; overflow-y: scroll; padding-bottom: 60px"
            :src="preRbUrl"
            frameborder="0"
          ></iframe>
        </div>
        <div class="preRebate_footer">
          <div class="preRebate_footer_cont">
            <img src="../assets/imgs/rb1.png" alt="" />
            <img @click="enterGame" src="../assets/imgs/rb2-1.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="healthBool" style="width: 100%; height: 100%; background: #fff; position: fixed; top: 0; left: 0">
      <img
        style="width: 100%; position: absolute; top: 50%; transform: translate(0, -50%)"
        v-if="gameDist == 'vertical'"
        src="../assets/imgs/health1.png"
        alt=""
      />
      <img
        style="width: 100%; position: absolute; top: 50%; transform: translate(0, -50%)"
        v-else
        src="../assets/imgs/health2.png"
        alt=""
      />
    </div>
    <div v-else>
      <Modal></Modal>
      <!-- 飘浮图标 -->
      <hover-icon></hover-icon>
      <!-- 跳转页面确认框 -->
      <open-confirm></open-confirm>
      <!-- 加载中 -->
      <Loading v-if="loading" class="ln-loading" size="50" type="spinner" vertical>加载中...</Loading>
      <!-- sdk红包按钮 -->
      <div
        v-show="rebateOpen"
        class="draggable-icon"
        ref="icon"
        :style="{ left: positionIcon.x + 'px', top: positionIcon.y + 'px' }"
        @mousedown="startDrag"
        @touchstart="startDrag"
        @click="openRebate"
      >
        <!-- <img src="../assets/imgs/rebate.png" alt="" /> -->
        <img ref="iconCont" :src="currentImage" alt="" />
        <Badge v-if="showRebateBadge" class="rebate-badge" dot> </Badge>
      </div>
      <!-- 加载sdk红包链接 -->
      <div class="lngame_rebate" v-if="rebatePop">
        <van-popup
          v-model="show"
          :position="position"
          @close="closePop"
          :close-on-click-overlay="isOverlay"
          :style="rebateStyle"
        >
          <iframe
            :src="rebateUrl"
            ref="iframe"
            style="width: 100%; height: 100%; overflow-y: scroll; background: #fff"
            frameborder="0"
          ></iframe>
        </van-popup>
        <van-popup v-model="kefu.show" position="bottom" close="closePopKefu" :style="{ height: '60%' }">
          <div class="closeRebate" @click="closeIframeKefu"><van-icon size="40" name="cross" /></div>
          <iframe
            id="lnkefu"
            :src="kefu.url"
            style="width: 100%; height: 100%; overflow-y: scroll"
            frameborder="0"
          ></iframe>
        </van-popup>

        <div
          v-if="rebatePop"
          style="width: 15.89%; height: 100%; position: absolute; right: 0%; top: 0; z-index: 10002"
          @click="closeBtn"
        ></div>
        <div
          v-if="rebatePop"
          :style="rebateCloseStyle"
          style="position: absolute; left: 84.11%; z-index: 10001"
          @click="closeBtn"
        >
          <img style="width: 30px" src="../assets/imgs/iconpull.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Modal from '@/components/Modal';
import HoverIcon from '@/components/HoverIcon';
import OpenConfirm from '@/components/OpenConfirm';
import { Loading } from 'vant';
import draggable from '@/draggable';
import server from '@/server/index';
import mixServer from '@/server/mixServer';
import { Badge } from 'vant';

import store from '@/store';
export default {
  name: 'Index',
  components: { Modal, HoverIcon, OpenConfirm, Loading, Badge },
  data() {
    return {
      isRebate: false,
      show: true,
      kefushow: true,
      rebateStyle: {
        height: '60%',
        width: '84.11%',
      },
      rebateCloseStyle: {
        top: '40%',
      },
      position: 'bottom',
      isOverlay: true,
      showRebateBadge: false, // 是否显示红包悬浮窗红点
      positionIcon: { x: 0, y: 0 }, // 初始位置
      isDragging: false,
      startX: 0,
      startY: 0,
      containerRect: null,
      currentImage: '',
    };
  },
  computed: {
    ...mapState([
      'loading',
      'rebateOpen',
      'rebateUrl',
      'kefu',
      'rebatePop',
      'verticalRb',
      'healthBool',
      'gameDist',
      'autoOpenReb',
      'preRb',
      'preRbUrl',
      'isOpenRebate',
      'rebateIcon',
    ]),
  },
  mounted() {
    // if (this.rebateOpen) {
    // this.setDrag();
    // }
    this.setInitialPosition();
    // 添加鼠标移动和释放事件的监听
    document.addEventListener('mousemove', this.onDrag);
    document.addEventListener('mouseup', this.stopDrag);
    document.addEventListener('touchmove', this.onDrag, { passive: false });
    document.addEventListener('touchend', this.stopDrag);
  },
  beforeDestroy() {
    // 移除事件监听
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('mouseup', this.stopDrag);
    document.removeEventListener('touchmove', this.onDrag);
    document.removeEventListener('touchend', this.stopDrag);
  },
  watch: {
    verticalRb(val) {
      if (this.verticalRb == 1) {
        this.rebateStyle = { height: '100%', width: '84.11%', overflow: 'hidden' };
        this.rebateCloseStyle = { top: '0%' };
        this.position = 'left';
        this.isOverlay = false;
      }
    },
    autoOpenReb(val) {
      if (val) {
        this.openRebate();
      }
    },
    isOpenRebate(val) {
      if (val) {
        this.openRebate();
      } else {
        this.closePop();
      }
    },
    gameDist(val) {
      this.sendOcDiret();
    },
    preRb(val) {},
    rebateIcon(val) {
      this.currentImage = val.left_side;
    },
  },
  created() {
    // 页面一加载就通知ios客户端横竖屏 vertical/cross
    // mixServer.getConfig().then(data => {
    //   console.log(data)
    // })
    console.log('4-10');
    window.addEventListener('message', (e) => {
      const { action } = e.data;
      if (action == 'REBATE') {
        this.enterGame();
      }

      // 通知中心显示红包悬浮窗红点
      if (action == 'SHOW_REBATE_BADGE') {
        this.showRebateBadge = true;
      } else if (action == 'HIDE_REBATE_BADGE') {
        // 通知中心取消显示红包悬浮窗红点
        this.showRebateBadge = false;
      }
    });
  },
  methods: {
    reload() {
      location.reload();
    },
    sendOcDiret() {
      try {
        console.log(this.gameDist);
        window.webkit.messageHandlers['direction'].postMessage({ params: this.gameDist });
      } catch (err) {
        console.log('浏览器不支持跳转', err);
      }
    },
    openRebate() {
      this.isRebate = true;
      this.show = true;
      store.commit('SET_RABTOPEN', true);
      // console.log(this.rebateUrl)
      // store.commit('SET_REBATEURL', this.rebateUrl);
      this.$nextTick(() => {
        this.$refs.iframe.src = this.rebateUrl;
      });
    },
    closePop() {
      this.show = false;
      this.$refs.iframe.src = '';
      this.closeBtn();
    },
    closePopKefu() {
      store.commit('SET_OPENKEFU', { show: false });
    },
    closeIframeKefu() {
      store.commit('SET_OPENKEFU', { show: false });
    },
    closeIframe() {
      this.isRebate = false;
      console.log(this.isRebate);
      // store.commit('SET_OPEN', true);
    },
    closeBtn() {
      store.commit('SET_RABTOPEN', false);
    },
    // 前置红包进入游戏
    enterGame() {
      store.commit('SET_PRERB', false);
      if (store.state.is_open_health == 1) {
        store.commit('SET_HEALTH', true);
        setTimeout(() => {
          store.commit('SET_HEALTH', false);
          server.init();
        }, 2000);
      } else {
        server.init();
      }
    },
    // 红包按钮拖动
    setDrag() {
      const el = this.$refs.rebateIcon;
      const { clientWidth, clientHeight } = document.documentElement;
      // 移动端的拖动
      draggable(el, {
        drag: (e) => {
          const touch = e.changedTouches[0];
          // 定位到元素中间
          const EL_MIDDLE = el.clientHeight / 2;
          let top = touch.clientY - EL_MIDDLE;
          const minTop = 0;
          const maxTop = clientHeight - el.clientHeight;
          const resultTop = Math.min(Math.max(minTop, top), maxTop);
          if (clientHeight <= 0) {
            if (top <= 0) top = 0;
            el.style.top = `${top}px`;
          } else {
            el.style.top = `${resultTop}px`;
          }
        },
      });
    },
    setInitialPosition() {
      this.$nextTick(() => {
        const iconHeight = this.$refs.icon.offsetHeight;
        this.positionIcon = {
          x: 0,
          y: (window.innerHeight - iconHeight) / 2,
        };
      });
    },
    startDrag(e) {
      this.isDragging = true;

      // 处理鼠标和触摸事件
      const clientX = e.clientX || (e.touches && e.touches[0].clientX);
      const clientY = e.clientY || (e.touches && e.touches[0].clientY);

      this.startX = clientX - this.positionIcon.x;
      this.startY = clientY - this.positionIcon.y;

      // e.preventDefault();
    },
    onDrag(e) {
      if (!this.isDragging) return;
      // 处理鼠标和触摸事件
      const clientX = e.clientX || (e.touches && e.touches[0].clientX);
      const clientY = e.clientY || (e.touches && e.touches[0].clientY);

      let newX = clientX - this.startX;
      let newY = clientY - this.startY;
      const iconWidth = this.$refs.icon.offsetWidth;
      const iconHeight = this.$refs.icon.offsetHeight;
      newX = Math.max(0, Math.min(newX, window.innerWidth - iconWidth));
      newY = Math.max(0, Math.min(newY, window.innerHeight - iconHeight));
      this.positionIcon = { x: newX, y: newY };
      const iconCenter = newX + iconWidth / 2;
      const boundaryThreshold = window.innerWidth * 0.1;
      if (iconCenter <= boundaryThreshold) {
        this.currentImage = this.rebateIcon.left_side;
        this.$refs.iconCont.style.width = '30px';
      } else if (iconCenter >= window.innerWidth - boundaryThreshold) {
        this.currentImage = this.rebateIcon.right_side;
        this.$refs.iconCont.style.width = '30px';
      } else {
        this.currentImage = this.rebateIcon.full;
        this.$refs.iconCont.style.width = '60px';
      }
      // e.preventDefault();
    },
    stopDrag() {
      this.isDragging = false;

      const iconWidth = this.$refs.icon.offsetWidth;
      const iconCenter = this.positionIcon.x + iconWidth / 2;
      const screenCenter = window.innerWidth / 2;

      // 如果图标中心在屏幕左半边
      if (iconCenter <= screenCenter) {
        setTimeout(() => {
          this.positionIcon.x = 0; // 回到最左边
          this.currentImage = this.rebateIcon.left_side;
          this.$refs.iconCont.style.width = '30px';
        }, 1000);
      }
      // 如果图标中心在屏幕右半边
      else {
        setTimeout(() => {
          // 右边整圆和半圆
          if (iconWidth > 30) {
            this.positionIcon.x = window.innerWidth - iconWidth/2; // 回到最右边（减去图标宽度）
          } else {
            this.positionIcon.x = window.innerWidth - iconWidth; // 回到最右边（减去图标宽度）
          }
          this.currentImage = this.rebateIcon.right_side;
          this.$refs.iconCont.style.width = '30px';
        }, 1000);
      }
    },
  },
};
</script>
<style lang="scss">
/* @import url() */
// 加载中
.ln-loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
// .lngame_rebate{position: fixed;top: 0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.6);z-index: 900;}
.rebateBtn {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 901;
}
.rebate-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  z-index: 902;
}
#lnkefu #mobile .mobile-header .goBack {
  display: none !important;
}
.rebateBtn img {
  width: 40px;
}
.closeRebate {
  position: absolute;
  top: 2px;
  left: 1px;
  z-index: 999;
  opacity: 0;
}
.preRebate {
  width: 100%;
  height: 100vh;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
}
.preRebate_cont {
  width: 95%;
  height: 100%;
  overflow-y: scroll;
  margin: 0 auto;
}
.preRebate_footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: url(../assets/imgs/preRB_foot.png) no-repeat;
  background-size: 100% 100%;
}
.preRebate_footer_cont {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: space-around;
}
.preRebate_footer_cont img {
  width: 50px;
}
.draggable-icon {
  z-index: 901;
  left: 0;
  position: absolute;
  touch-action: none; /* 防止触摸事件的默认行为 */
  user-select: none; /* 防止文本选择 */
}
.draggable-icon img {
  width: 30px;
}
</style>
